import { __ } from '@/hub-shared/utils/i18n';

export type FeatureGateReason =
  | 'subscription_required'
  | 'missing_permission'
  | 'email_unverified'
  | 'limit_reached'
  | 'feature_disabled'
  | 'compliance_required';

export type FeatureGateSeverity = 'info' | 'warning' | 'error' | 'success';

export type FeatureGateDecision = {
  allowed: boolean;
  reason?: FeatureGateReason;
  message?: string;
  ctaLabel?: string;
  ctaHref?: string;
  severity?: FeatureGateSeverity;
};

type AdvancedUserManagementGateOptions = {
  advancedUserManagement: boolean;
  subscriptionTierUrl?: string;
  manageUserAccess?: boolean;
  requireManageUserAccess?: boolean;
};

export const allowGate = (): FeatureGateDecision => ({ allowed: true });

export const subscriptionRequiredGate = (subscriptionTierUrl?: string): FeatureGateDecision => ({
  allowed: false,
  reason: 'subscription_required',
  message: __('Cette option nécessite un abonnement supérieur.'),
  ctaLabel: subscriptionTierUrl ? __('Comparer les plans') : undefined,
  ctaHref: subscriptionTierUrl,
});

export const complianceSubscriptionRequiredGate = (
  subscriptionTierUrl?: string,
): FeatureGateDecision => ({
  ...subscriptionRequiredGate(subscriptionTierUrl),
  message: __('Vous n\'avez pas accès à Contrôle et Conformité avec votre plan actuel.'),
});

export const permissionsSubscriptionRequiredGate = (
  subscriptionTierUrl?: string,
): FeatureGateDecision => ({
  ...subscriptionRequiredGate(subscriptionTierUrl),
  message: __('Vous n\'avez pas accès aux permissions avancées avec votre plan actuel.'),
});

export const getAdvancedUserManagementGate = ({
  advancedUserManagement,
  subscriptionTierUrl,
  manageUserAccess = true,
  requireManageUserAccess = false,
}: AdvancedUserManagementGateOptions): FeatureGateDecision => {
  if (!advancedUserManagement) {
    return subscriptionRequiredGate(subscriptionTierUrl);
  }
  if (requireManageUserAccess && !manageUserAccess) {
    return {
      allowed: false,
      reason: 'missing_permission',
      message: __('Vous ne pouvez pas modifier ces paramètres. Demandez à un administrateur du cabinet.'),
    };
  }
  return allowGate();
};
